export default {
  GCP_GET_PRICING: 'GCP_GET_PRICING',
  GCP_GET_PRICING_SUCCESS: 'GCP_GET_PRICING_SUCCESS',
  GCP_GET_PRICING_ERROR: 'GCP_GET_PRICING_ERROR'
};



// WEBPACK FOOTER //
// ./src/constants/gcp/pricingTypes.js